<template>
    <v-dialog
            v-model="isDialogOpen"
            width="600"
    >
        <template v-slot:activator="{ on }" v-if="internalActivator">
            <v-btn
                    color="teal"
                    dark
                    text
                    v-on="on"
                    class="overline"
                    height="20px"
            >
                {{ $t('show') }}
            </v-btn>
        </template>
        <v-card>
            <v-card-text>
                <div class="title py-3">
                    {{ $t('productParams') }}
                </div>
                <v-divider class="mb-5"></v-divider>
                <v-simple-table hover>
                    <template v-slot:default>
                        <tbody>
                            <tr v-for="(item, idx) in attributes" :key="idx">
                                <td class="py-1">
                                    <div class="subtitle-2">{{ item.attribute_name }}:</div>
                                </td>
                                <td class="py-1">
                                    <div class="caption">{{ item.value_name.toUpperCase() }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="grey"
                        text
                        @click="$emit('close')"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "AttributesDialog",
        props: ['attributesData', 'isOpen', 'internalActivator'],
        computed: {
            attributes() {
                return this.attributesData;
            },

            isDialogOpen: {
                get() {
                    return this.isOpen;
                },
                set(value) {
                    if(!value) {
                        this.$emit('close', this.attributesData.product_id);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
